
const filePath = (...paths: string[]): ContactLensFilterAssetsResolver =>
  (file: string) => ['/assets-proxy', 'images', 'contactlens', ...paths, file].join('/')

type ContactLensFilterAssetsResolver = (file: string) => string

export const caption = filePath('caption')
export const color = filePath('color')
export const root = filePath()

export const assetsResolver = {
  caption,
  color,
  root,
} as const
export type AssetsResolver = typeof assetsResolver
